import React, { useEffect, useState } from 'react';

import Table from 'b2b-ui-components-lib/lib/components/table';
import { CELLTYPE_ENUM, getCellClass, getSortClass, isLinkType, SHOWROWS_ENUM, toggleSort } from './table.constant';
import TableFooter from './table-footer';
import { NoRecord } from './no-record';
import { v4 as uuidv4 } from 'uuid';

export const CustomTable = ({
  headers,
  contents,
  onCellClickHandler,
  onSortChange,
  totalPages,
  onPageChange,
  loader,
  showLoader,
  renderHeaderSection,
  onChange,
  showSearch,
  multipleSort,
  renderMessage,
  totalRecords,
  onClearFilter,
  updateParentRecords = () => {},
  renderSelectAll = () => {},
  CustomSearchFilter = () => {},
  paginationLength = 5,
  isRowSpanAllow = false,
  mergeKey = '',
  hideClearFilter = false,
  numberOfRowsToShow = SHOWROWS_ENUM.defaultValue
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [headersConfig, setHeadersConfig] = useState([]);
  const [showRows, setShowRows] = useState(numberOfRowsToShow);
  const [sortModel, setSortModel] = useState([]);
  const [activeColumn, setActiveColumn] = useState({});

  const [searchValue, setSearchValue] = useState('');
  const [searchType, SetSearchType] = useState('');

  const onShowRowsChange = (rows) => {
    setShowRows(rows);
  };

  useEffect(() => {
    setShowRows(numberOfRowsToShow);
  }, [numberOfRowsToShow]);

  // const filterChangeHandled = () => {

  //   if(filterChanged)
  //   {
  //     setShowRows(SHOWROWS_ENUM.defaultValue)
  //   }
  //   ;
  // }

  const keyMap = {};

  const onClear = () => {
    setSearchValue('');
    SetSearchType('');
    onClearFilter?.({ setShowRows, setCurrentPage });
  };

  const isNotFalsy = (value) => {
    return value !== undefined && value !== null && value !== '';
  };

  const checkBoxHandler = (isChecked, rowsInfo) => {
    const { rowData, rowIndex } = rowsInfo;
    contents[rowIndex] = rowData;
    updateParentRecords?.([...contents], isChecked, rowsInfo);
  };

  const getCellProps = (headerConfig, cellValue, rowIndex) => {
    const { sortType, cellType } = headerConfig;
    const properties = { className: getCellClass(cellType) };
    if (isLinkType(cellType)) {
      properties['onClick'] = onCellClickHandler ? () => onCellClickHandler({ headerConfig, cellValue, rowData: contents[rowIndex], rowIndex, sortType }) : () => {};
    }
    return properties;
  };

  const getCell = (config, value, rowIndex) => {
    return (
      <React.Fragment>
        <div
          title={config.cellType === CELLTYPE_ENUM.LINK ? value : ''}
          key={rowIndex + value}
          {...getCellProps(config, value, rowIndex)}
          style={{
            wordWrap: 'break-word'
          }}
        >
          {isNotFalsy(value) ? (config.formatter ? config.formatter(value, { onChange: checkBoxHandler, config, value, rowIndex, rowData: contents[rowIndex] }) : value) : '-'}
        </div>
        {config.subCell ? config.subCell(value, contents[rowIndex]) : ''}
      </React.Fragment>
    );
  };

  const getSortElement = (sortType, headerName) => {
    let sortClass = 'default';
    if (activeColumn['headerName'] === headerName || multipleSort) {
      sortClass = getSortClass(sortType);
    }
    return <span className={sortClass}></span>;
  };

  const getSortModel = () => headersConfig.filter(({ isSort }) => isSort);

  const emitSort = (headers, clickedColumn) => {
    const currentSortModel = getSortModel();
    setSortModel(clickedColumn); // sortModel
    setActiveColumn(clickedColumn);
    onSortChange && onSortChange(currentSortModel);
  };

  const onSortChangeHandler = (columnIndex) => {
    setHeadersConfig((prevState) => {
      const clickedColumn = { ...prevState[columnIndex] };
      clickedColumn['sortType'] = toggleSort(clickedColumn['sortType']);
      prevState[columnIndex] = clickedColumn;
      emitSort(prevState, clickedColumn);
      return [...prevState];
    });
  };

  const getTableHeaderProps = (isSort, columnIndex) => {
    return isSort ? { onClick: () => onSortChangeHandler(columnIndex) } : {};
  };

  const getHeaders = (headerList) => {
    if (Array.isArray(headerList)) {
      return headerList.map(({ headerName, isSort, sortType }, index) => {
        return (
          <th key={uuidv4()} {...getTableHeaderProps(isSort, index)}>
            <div className="b2b-lib-data_head">
              <span className="b2b-lib-title_text">{headerName}</span>
              {isSort ? getSortElement(sortType, headerName) : ''} {/* add classes "dafault, descending, ascending" accodingly as on status  */}
            </div>
          </th>
        );
      });
    }
    return [];
  };

  const getRowProperties = ({ rowSpan }, rowData) => {
    const rowSpanValue = rowSpan && rowSpan(rowData);
    let properties = {};
    if (rowSpanValue) {
      properties['rowspan'] = rowSpanValue;
      properties['className'] = 'expand_row';
    }
    return properties;
  };

  const getBodyElements = (headerList, content, rowIndex, shouldNotAddColumn) => {
    if (Array.isArray(headerList)) {
      return headerList.map((headerConfig, index) => {
        const { headerName, key } = headerConfig;
        const tdProperties = getRowProperties(headerConfig, content);
        if (tdProperties && tdProperties?.rowspan > 0) {
          if (shouldNotAddColumn) {
            return null;
          }
        }
        return (
          <td key={uuidv4()} {...tdProperties}>
            <div className="b2b-lib-td_label"> {headerName}</div>
            {getCell(headerConfig, content[key], rowIndex)}
          </td>
        );
      });
    }
    return [];
  };

  const addRowLine = (id) => {
    let flag = false;
    if (keyMap.hasOwnProperty(id)) {
      return delete keyMap[id];
    }
    keyMap[id] = id;
    return flag;
  };

  const getBody = (headerList, contents, showRows) => {
    if (Array.isArray(contents) && contents.length > 0) {
      return contents.slice(0, showRows).map((content, index) => {
        let rowClassName = '';
        const shouldAddRowLine = addRowLine(content[mergeKey]);
        if (isRowSpanAllow && content?.isRowSpanAllowed && shouldAddRowLine) {
          rowClassName = shouldAddRowLine ? 'hide_border' : '';
        }
        return (
          <tr key={uuidv4()} className={rowClassName}>
            {getBodyElements(headerList, content, index, shouldAddRowLine)}
          </tr>
        );
      });
    }
    return [];
  };

  const renderSearch = () => {
    if (showSearch && !showLoader) {
      return (
        <div className="filter_strip">
          {renderMessage && renderMessage}
          <div className="searchFilter">
            <CustomSearchFilter searchValue={searchValue} setSearchValue={setSearchValue} searchType={searchType} SetSearchType={SetSearchType}></CustomSearchFilter>
          </div>
        </div>
      );
    }
  };

  const getCurrentState = () => {
    const searchModel = searchType.apiKey ? { [searchType.apiKey]: searchValue } : '';
    return {
      sort: getSortModel(),
      currentPage,
      showRows,
      searchModel,
      activeColumn
    };
  };

  const onPageChangeHandler = (value) => {
    setCurrentPage(value);
    onPageChange && onPageChange(value);
  };

  useEffect(() => {
    setHeadersConfig(headers);
  }, [headers]);

  useEffect(() => {
    onChange && onChange({ ...getCurrentState() });
  }, [currentPage, sortModel, showRows, searchValue]);

  // useEffect(() => {
  //   filterChangeHandled();
  // },[filterChanged])
  // console.log("table rows***", showRows);
  return (
    <React.Fragment>
      {renderHeaderSection(showLoader)}
      {showLoader ? (
        loader
      ) : (
        <React.Fragment>
          {renderSearch()}
          {renderSelectAll?.()}
          <Table>
            <table style={{ tableLayout: 'fixed' }} className="content_table">
              <thead>
                <tr key={uuidv4()}>{getHeaders(headersConfig)}</tr>
              </thead>
              <tbody>{contents.length > 0 && getBody(headersConfig, contents, showRows)}</tbody>
            </table>
            {contents.length === 0 && <NoRecord onClearFilter={onClear} hideClearFilter={hideClearFilter} />}
          </Table>
        </React.Fragment>
      )}
      {totalRecords !== undefined && (
        <TableFooter
          totalRecords={totalRecords}
          hide={showLoader || totalRecords <= SHOWROWS_ENUM.defaultValue}
          currentPage={currentPage}
          setCurrentPage={onPageChangeHandler}
          totalPages={paginationLength}
          emitShowRowsChange={onShowRowsChange}
          paginationLength={paginationLength}
          numberOfRowsToShow={showRows}
        ></TableFooter>
      )}
    </React.Fragment>
  );
};
